import { ApolloProvider } from '@apollo/client';
import '@mantine/carousel/styles.css';
import { MantineProvider } from '@mantine/core';
import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import { RouterProvider, createRouter } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { apolloClient } from './apollo';
import './assets/goldplay/fonts.css';
import { ShoppingCartProvider } from './contexts';
import './main.css';
import { routeTree } from './routeTree.gen';
import { theme } from './theme';

const router = createRouter({ routeTree });

// Register the router instance for type safety
declare module '@tanstack/react-router' {
	interface Register {
		router: typeof router;
	}
}

createRoot(document.getElementById('root')!).render(
	<StrictMode>
		<ApolloProvider client={apolloClient}>
			<MantineProvider theme={theme}>
				<ShoppingCartProvider>
					<RouterProvider router={router} />
				</ShoppingCartProvider>
			</MantineProvider>
		</ApolloProvider>
	</StrictMode>
);
